import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Message } from 'src/app/interfaces/message.model';
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users.service';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from 'src/app/components/password-management/change-password/change-password.component';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit {

  dropdownOpen: boolean;
  icPerson = icPerson;
  userName: string = '';

  constructor(private popover: PopoverService,
    // private popoverRef: PopoverRef<ToolbarUserDropdownComponent>,
    private userService: UsersService,
    private broadcastService:BroadcastService,
    private router: Router,
    private dialog: MatDialog,
    private cookieService: CookieService,
    private cd: ChangeDetectorRef) { }

  ngOnInit() {
    this.userName = this.cookieService.get('user_name')
  }


  callUserLogout(){
   
   
    if(localStorage.getItem('user_session_id')){
      this.userService.removeUserLocalStorage();
        this.router.navigate(['/']);
        console.log('user logged out')
    }
    
   
        
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  showChangePasswordPopup(type){
    let url = location.href;
    
    this.dialog.open(ChangePasswordComponent, {
      data: {url:url},
      width: 'auto',
      height: 'auto',
      minWidth: '500px'
    }).afterClosed().subscribe(item => {
      console.log(item);
      if(item === 'yes'){
        
        
      }
      
      
    })
  }
}
